__turbopack_context__.v({
  "centre": "RepairRequestServiceCentre-module-scss-module__OFzana__centre",
  "name": "RepairRequestServiceCentre-module-scss-module__OFzana__name",
});
